module.exports = __webpack_public_path__ + "b7c34b0aa604c53a50b288d6c1700b0c.pdf";